import { render } from "./UserCategoryFieldMapping.vue?vue&type=template&id=41e76a20"
import script from "./UserCategoryFieldMapping.vue?vue&type=script&lang=js"
export * from "./UserCategoryFieldMapping.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__